<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal
      title="选择项目"
      :visible="visible"
      @cancel="cancel"
      :footer="null"
      width="800px"
    >
      <a-input-search
        style="margin-bottom: 16px"
        placeholder="请输入项目名称/设计编号搜索"
        enter-button
        @search="onSearch"
      ></a-input-search>

      <a-table
        :indentSize="0"
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        :rowClassName="() => 'clickable'"
        :customRow="
          (record) => {
            return {
              on: {
                click: () => {
                  onTableRowClick(record);
                },
              },
            };
          }
        "
      >
        <a-table-column title="设计编号" data-index="designCode" width="120px">
        </a-table-column>

        <a-table-column title="项目名称" data-index="name"> </a-table-column>

        <a-table-column title="状态" align="center">
          <template slot-scope="text">
            <div v-if="text.contract"></div>
            <DataDictFinder
              dictType="taskReviewStatus"
              :dictValue="text.contract.configureStatus"
              iconType="badge"
            />
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      visible: false,
    };
  },

  computed: {
    ...mapState("projectSelector", [
      "loading",
      "current",
      "pageSize",
      "list",
      "total",
    ]),
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {
    ...mapMutations("projectSelector", [
      "setCurrent",
      "setPageSize",
      "setSearchValue",
    ]),
    ...mapActions("projectSelector", ["getList"]),

    onChange(pagination) {
      this.setCurrent(pagination.current);
      this.setPageSize(pagination.pageSize);
      this.getList();
    },

    onSearch(value) {
      this.setSearchValue(value);
      this.setCurrent(1);
      this.getList();
    },

    onTableRowClick(record) {
      // if (!record.contract || record.contract.configureStatus !== "approved") {
      //   this.$message.error("项目配置尚未审核通过！");
      //   return;
      // }

      this.$emit("change", record);
      this.cancel();
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>